const users = [
  { email: 'angie@plykea.com', name: 'Angie', colour: '#2a78d6', team: 'sales' },
  { email: 'katie@plykea.com', name: 'Katie', colour: '#fe860f', team: 'sales' },
  { email: 'combined', name: 'Team', colour: '#000000', team: 'sales' },
  { email: 'anne@plykea.com', name: 'Anne', colour: '#8e4208', team: 'sales' },
  { email: 'kath@plykea.com', name: 'Kath', colour: '#78bf7b', team: 'sales' },
  { email: 'kate@plykea.com', name: 'Kate', colour: '#22b8fb', team: 'sales' },
  { email: 'laura@plykea.com', name: 'Laura', colour: '#6915b6', team: 'sales' },
  { email: 'pip@plykea.com', name: 'Pip', colour: '#c635b0', team: 'sales' },
  { email: 'leah@plykea.com', name: 'Leah', colour: '#0d23ff', team: 'sales' },
  { email: 'kristine@plykea.com', name: 'Kristine', colour: '#298954', team: 'sales' },
  { email: 'fiona@plykea.com', name: 'Fiona', colour: '#dd8cc3', team: 'sales' },
  { email: 'daniel@plykea.com', name: 'Daniel', colour: '#ed324b', team: 'sales' },
  { email: 'myles@plykea.com', name: 'Myles', colour: '#930660', team: 'sales' }
]

const quoteTeam = users
  .filter((u) => u.team === 'sales' && u.email.includes('@'))
  .sort((a, b) => a.name.localeCompare(b.name))

export default {
  users,
  quoteTeam
}
